import * as turf from '@turf/turf';
import { GeoJSONObject } from '@turf/turf';
import { map } from 'rxjs/operators';

export class MapBoxGrid {
  layer: any;
  opts: any;

  rotateAngle:number = 0;
  selectedIds = [];

  constructor(layer, gridData) {
    this.layer = layer;
    this.rotateAngle = gridData.rotateAngle;
    this.selectedIds = gridData.selectedIds;

    return this.add();
  }

  private add(): any {
    // List of coordinates of the layer
    const layer = this.layer;
    
    // Create Bounding box of the layer
    const lineBbox = turf.bbox(layer);

    // Enlarge the bounding box to prevent unaccurate grid
    const buffer = turf.buffer(turf.bboxPolygon(lineBbox), 10, { units: 'meters' });
    const bufferBbox = turf.bbox(buffer);

    const bufferPolygon = turf.bboxPolygon(bufferBbox);
    const bufferPolygonCenter = turf.center(bufferPolygon);
    const rotatedPolygon = turf.transformRotate(bufferPolygon, this.rotateAngle, { pivot: bufferPolygonCenter.geometry });

    const unionPolygon = turf.union(bufferPolygon, rotatedPolygon);

    const boundingBoxUnion = turf.bbox(unionPolygon);

    // Create grid from the englarged bounding box above
    const squareGrid = turf.squareGrid(boundingBoxUnion, 1, { units: 'meters' });

    const squareGridPivot = turf.center(squareGrid);
    const rotatedSquareGrid = turf.transformRotate(squareGrid, this.rotateAngle, { pivot: squareGridPivot.geometry  });

    // Loop through all created grid and find the intersection and return new value
    const gridLength = rotatedSquareGrid.features.length;
    let i = gridLength;
    while (i--) {
      const grid: any = rotatedSquareGrid.features[i];
      const intersection = turf.intersect(grid.geometry, layer);

      if (intersection) {
        const isSelected = this.selectedIds.includes(i) ? true : false;
        grid.id = i;
        grid.geometry = intersection.geometry as any;
        grid.properties = {
          fill: 'transparent',
          'stroke-color': 'red',
          selected: isSelected,
          id: i
        };  
      } else {
        grid.properties = {
          fill: 'transparent',
          'stroke-color': 'red',
          selected: false,
          id: -1
        };   
      }
    }
    return rotatedSquareGrid;
  }
}

/*
import * as turf from '@turf/turf';
import { GeoJSONObject } from '@turf/turf';
import { map } from 'rxjs/operators';

export class MapBoxGrid {
  layer: any;
  opts: any;

  rotateAngle:number = 0;
  selectedIds = [];

  constructor(layer, _rotateAngle, _selectedIds, opts?) {
    this.layer = layer;
    this.opts = opts;
    this.rotateAngle = _rotateAngle;
    this.selectedIds = _selectedIds;


    return this.add();
  }

  private add(): any {
    // List of coordinates of the layer
    const layer = this.layer.features[0];


    if (this.opts.selectedIds.length > 0) {
      this.selectedIds = this.opts.selectedIds;
    }

    // Create Bounding box of the layer
    const lineBbox = turf.bbox(layer);

    // Enlarge the bounding box to prevent unaccurate grid
    const buffer = turf.buffer(turf.bboxPolygon(lineBbox), 10, { units: 'meters' });
    const bufferBbox = turf.bbox(buffer);

    const bufferPolygon = turf.bboxPolygon(bufferBbox);
    const bufferPolygonCenter = turf.center(bufferPolygon);
    const rotatedPolygon = turf.transformRotate(bufferPolygon, this.rotateAngle, { pivot: bufferPolygonCenter.geometry });

    const unionPolygon = turf.union(bufferPolygon, rotatedPolygon);

    const boundingBoxUnion = turf.bbox(unionPolygon);

    // Create grid from the englarged bounding box above
    const squareGrid = turf.squareGrid(boundingBoxUnion, 1, { units: 'meters' });

    const squareGridPivot = turf.center(squareGrid);
    const rotatedSquareGrid = turf.transformRotate(squareGrid, this.rotateAngle, { pivot: squareGridPivot.geometry  });

    // Loop through all created grid and find the intersection and return new value
    const gridLength = rotatedSquareGrid.features.length;
    let i = gridLength;
    while (i--) {
      const grid: any = rotatedSquareGrid.features[i];
      const intersection = turf.intersect(grid.geometry, layer);

      if (intersection) {
        grid.id = i;
        grid.geometry = intersection.geometry as any;
        grid.properties = {
          fill: 'transparent',
          'stroke-color': 'red',
          selected: false,
          id: i
        };  

        if (this.selectedIds.includes(grid.id)) {
          grid.properties.selected = true;
        } 
      } else {
        grid.properties = {
          fill: 'transparent',
          'stroke-color': 'red',
          selected: false,
          id: -1
        };   
      }
    }
    

    return rotatedSquareGrid;
  }
}
*/
